import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DEFAULT_LOCALE } from '../constants'
import first from 'lodash/first'

export const useDateRange = ({ cronStart, cronEnd, setFieldValue }) => {
  const { i18n } = useTranslation()
  const lang = i18n.language || DEFAULT_LOCALE

  const locale = first(lang?.split('-'))

  const getHandleDateChange = (field) => (value) =>
    setFieldValue(field, value?.[0])

  const today = new Date().setHours(0, 0, 0, 0)

  const cronStartValue = useMemo(() => {
    if (!cronStart) return
    return new Date(cronStart)
  }, [cronStart])

  const cronEndValue = useMemo(() => {
    if (!cronEnd) return
    return new Date(cronEnd)
  }, [cronEnd])

  return {
    getHandleDateChange,
    today,
    cronStartValue,
    cronEndValue,
    locale
  }
}
